import React, { useEffect, useState } from "react";
import { ToastContainer } from 'react-toastify';
//import useScript from "../hooks/UseScript";
import Stepper from "./StepperComponent";
import Step1 from "./Step1";
import Step2Simple from "./Step2Simple";
import Step2Advanced from "./Step2Advanced";
import Step3Advanced from "./Step3Advanced";
import Step3ResultSimple from "./Step3SimpleResult";

import "../css/normalize.css";
import "../css/webflow.css";
import "../css/salarysimwebflow.css";
import "../css/salarysimwebflow_custom.css";
import "../css/salarysim.css";

import { UseSalarySimContext } from "../Context/SalarySimContext";
import SimulationMode from "./SimulationModeComponent";
import Footer from "./FooterComponent";
import { LanguageSelectorComponent } from "./LanguageSelectorComponent";
import SalarySimService from "../services/SalarySimService";
import MapService from "../services/MapService";
import { UseConfigContext } from "../Context/ConfigContext";
import { UseTranslationContext } from "../Context/TranslationContext";
import { UseCodeListContext } from "../Context/CodeListContext";
import { UseToastContext, toastType } from "../Context/ToastContext";
import ResultData, { Cl_Pacible } from "../Model/ResultData";
import GSOHeaderComponent from "./GsoHeaderComponent";

import Lottie from "lottie-react";
import spinner from "../FormModel/lottie_spinner_blue.json";
import SimulationBlockerComponent from "./SimulationBlockerComponent";

export enum FormStatus {
  IDLE = 0,
  WAITING = 1,
  VALID = 2,
  INVALID = 3,
  IGNORED_FOR_VALIDATION = 4
}

export default function MainPage() {
  //const webflow_script = useScript(process.env.PUBLIC_URL + "/js/webflow.js");
  const { currentLanguage, getKeyFromKeyId } = UseTranslationContext();
  const { getCodeListKey, getJointComiteeKey } = UseCodeListContext();
  const { getServiceUrl, configKeys, isConfigLoaded, checkInternalVersion } = UseConfigContext();
  const { popToast } = UseToastContext();

  const {isSimpleSimulationMode,salarySimFormData,salarySimAdvancedFormData,UpdateSalarySimMappedData,UpdateSalarySimResultData, CallbackPrestaLoaded, ToggleSimulationMode} = UseSalarySimContext();

  const [salarySimulationInProgress, setSalarySimulationInProgress] = useState(false);
  const [computeButtonStepDisplay, setComputeButtonStepDisplay] = useState(false);

  const [step, setStep] = React.useState(1);

  // PRESTA FORM TRIGGER
  useEffect(() => {
    ResetStepper();
    setStep(1);
  }, [isSimpleSimulationMode]);

  const [prestaImportFromUrlCompleted, setPrestaImportFromUrlCompleted] = useState(false);

  useEffect(() => {
    if(isConfigLoaded == true && checkInternalVersion() == true && prestaImportFromUrlCompleted == false)
    {
      const queryParams = new URLSearchParams(window.location.search);
      const employer = queryParams.get('arg1');
      const employee = queryParams.get('arg2');
      
      if(employer && employee)
      {
        if(ToggleSimulationMode != undefined )
        {
          ToggleSimulationMode(false);
        }
      }

      setPrestaImportFromUrlCompleted(true);
    }
  }, [isConfigLoaded]);

  const [formStep1PrestaLoaded, setFormStep1PrestaLoaded] = useState(false);
  const [formStep2PrestaLoaded, setFormStep2PrestaLoaded] = useState(false);
  const [formStep3PrestaLoaded, setFormStep3PrestaLoaded] = useState(false);

  const PrestaDataLoadedCallBack = (loadedStep : number) => {
    switch(loadedStep)
    {
      case 1:
        setFormStep1PrestaLoaded(true);
      break;
      case 2:
        setFormStep2PrestaLoaded(true);
      break;
      case 3:
        setFormStep3PrestaLoaded(true);
      break;
    }
  }

  useEffect(() => {
    if(formStep1PrestaLoaded && formStep2PrestaLoaded && formStep3PrestaLoaded)
    {
      CallbackPrestaLoaded();
    }
  }, [formStep1PrestaLoaded,formStep2PrestaLoaded,formStep3PrestaLoaded]);


  // NAVIGATION AND FORM BULK NAVIGATION AND CALLBACK
  const [formStepperStepTarget, setFormStepperStepTarget] = useState(0);

  const [requestFormValidation, setRequestFormValidation] = useState(new Array<number>());

  const [formStateValidationStep1, setFormStateValidationStep1] = useState(FormStatus.IDLE);
  const [formStateValidationStep2, setFormStateValidationStep2] = useState(FormStatus.IDLE);
  const [formStateValidationStep3, setFormStateValidationStep3] = useState(FormStatus.IDLE);

  useEffect(() => {
    ResetStepper();
    setStep(1);
  }, [isSimpleSimulationMode]);
  
  const ResetStepper = () => {
    setRequestFormValidation(new Array<number>());

    setFormStateValidationStep1(FormStatus.IDLE);
    setFormStateValidationStep2(FormStatus.IDLE);
    setFormStateValidationStep3(FormStatus.IDLE);
  };

  // We ask for changing to a specific form step
  const RequestStepChange = (wantedStep: number, askForValidation : boolean = true) => {
    if (step > wantedStep || askForValidation == false) { // we allow to leave the step without validation
      setStep(wantedStep);
    }
    else if (step < wantedStep) { // we request a validation for each step until we reach wantedStep
      setFormStepperStepTarget(wantedStep);
        let formsToValidate = new Array<number>();

        formsToValidate.push(1);
        setFormStateValidationStep1(FormStatus.WAITING);

        if (wantedStep > 2) {
          formsToValidate.push(2);
          setFormStateValidationStep2(FormStatus.WAITING);
        }

        if (isSimpleSimulationMode == false && wantedStep > 3) {
          formsToValidate.push(3);
          setFormStateValidationStep3(FormStatus.WAITING);
        }

        setRequestFormValidation(formsToValidate);
    }
  };

  
  // We ask for changing to a specific form step
  const RequestNextStep = (wantedStep: number) => {

        setFormStepperStepTarget(wantedStep);
        let formsToValidate = new Array<number>();

        if(wantedStep == 2)
        {
          formsToValidate.push(1);
          setFormStateValidationStep1(FormStatus.WAITING);
        }
        else if(wantedStep == 3) // we are on step 2, we ignore step 1
        {
          setFormStateValidationStep1(FormStatus.IGNORED_FOR_VALIDATION);

          formsToValidate.push(2);
          setFormStateValidationStep2(FormStatus.WAITING);
        }
        else if(wantedStep == 4) // we are on step 3
        {
          if (isSimpleSimulationMode == false) {
            setFormStateValidationStep1(FormStatus.IGNORED_FOR_VALIDATION);
            setFormStateValidationStep2(FormStatus.IGNORED_FOR_VALIDATION);

            formsToValidate.push(3);
            setFormStateValidationStep3(FormStatus.WAITING);
          }
        }

        setRequestFormValidation(formsToValidate);
      };


  const FormValidationCallback = (stepCallback: number,formValidationSuccess: boolean) => {
    switch (stepCallback) {
      case 1:
        setFormStateValidationStep1(
          formValidationSuccess ? FormStatus.VALID : FormStatus.INVALID
        );
        break;
      case 2:
        setFormStateValidationStep2(
          formValidationSuccess ? FormStatus.VALID : FormStatus.INVALID
        );
        break;
      case 3:
        setFormStateValidationStep3(
          formValidationSuccess ? FormStatus.VALID : FormStatus.INVALID
        );
        break;
    }
  };

  const ComputeResultButtonClick = () => {
    if(salarySimulationInProgress == false)
    {
      let formsToValidate = new Array<number>();  

      formsToValidate.push(1);
      setFormStateValidationStep1(FormStatus.WAITING);
  
      formsToValidate.push(2);
      setFormStateValidationStep2(FormStatus.WAITING);
  
      if(!isSimpleSimulationMode)
      {
        formsToValidate.push(3);
        setFormStateValidationStep3(FormStatus.WAITING);
      }
  
      setFormStepperStepTarget(isSimpleSimulationMode?3:4);
      setRequestFormValidation(formsToValidate);
    }
  };

  // we check the results of each form validation
  useEffect(() => {
    let allowedStep = 1;
    if (requestFormValidation != null && requestFormValidation.length > 0)
    {
      if (isSimpleSimulationMode)
      {
        if (formStepperStepTarget == 1)
        {
          ResetStepper();
          setStep(1);
        }
        else if (formStepperStepTarget == 2) {
          // only step 1 must be valid
          var form1IsValidOrSkipped = (formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep1 == FormStatus.VALID)?true:false;
          if (form1IsValidOrSkipped)
          {
            allowedStep = 2;

            ResetStepper();
            setStep(allowedStep);
          }
        }
        else if (formStepperStepTarget == 3)
        {
          // step 1 and 2 must be ready
          let stateStep1 = formStateValidationStep1 == FormStatus.VALID || formStateValidationStep1 == FormStatus.INVALID || formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION;
          let stateStep2 = formStateValidationStep2 == FormStatus.VALID || formStateValidationStep2 == FormStatus.INVALID || formStateValidationStep2 == FormStatus.IGNORED_FOR_VALIDATION;
          if (stateStep1 && stateStep2) {
            // both steps have finished the validation ( with or without success )

            var form1IsValidOrSkipped = (formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep1 == FormStatus.VALID)?true:false;
            var form2IsValidOrSkipped = (formStateValidationStep2 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep2 == FormStatus.VALID)?true:false;

            if (form1IsValidOrSkipped)
            {
              allowedStep = 2;
            }

            if (form1IsValidOrSkipped && form2IsValidOrSkipped)
            {
              allowedStep = 3;
              calculer();
            }

            ResetStepper();
            setStep(allowedStep);
          }
        }
      }
      // ADVANCED SIMULATION MODE
      else
      {
        if (formStepperStepTarget == 1)
        {
          ResetStepper();
          setStep(1);
        } 
        else if (formStepperStepTarget == 2)
        {
          // only step 1 must be valid
          var form1IsValidOrSkipped = (formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep1 == FormStatus.VALID)?true:false;
          if (form1IsValidOrSkipped)
          {
            allowedStep = 2;

            ResetStepper();
            setStep(allowedStep);
          }
        } 
        else if (formStepperStepTarget == 3)
        {

          // step 1 and 2 must be ready or ignored 
          let stateStep1 = formStateValidationStep1 == FormStatus.VALID || formStateValidationStep1 == FormStatus.INVALID || formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION;
          let stateStep2 = formStateValidationStep2 == FormStatus.VALID || formStateValidationStep2 == FormStatus.INVALID || formStateValidationStep2 == FormStatus.IGNORED_FOR_VALIDATION;
          if (stateStep1 && stateStep2)
          {
            // both steps have finished the validation ( with or without success )
            if (formStateValidationStep1 == FormStatus.VALID || formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION) {
              allowedStep = 2;
            }

            var form1IsValidOrSkipped = (formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep1 == FormStatus.VALID)?true:false;
            var form2IsValidOrSkipped = (formStateValidationStep2 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep2 == FormStatus.VALID)?true:false;
            
            if (form1IsValidOrSkipped && form2IsValidOrSkipped)
            {
              allowedStep = 3;
            }

            ResetStepper();
            setStep(allowedStep);
          }
        }
        else if (formStepperStepTarget == 4)
        {
          // step 1 and 2 must be ready
          let stateStep1 = formStateValidationStep1 == FormStatus.VALID || formStateValidationStep1 == FormStatus.INVALID || formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION;
          let stateStep2 = formStateValidationStep2 == FormStatus.VALID || formStateValidationStep2 == FormStatus.INVALID || formStateValidationStep2 == FormStatus.IGNORED_FOR_VALIDATION;
          let stateStep3 = formStateValidationStep3 == FormStatus.VALID || formStateValidationStep3 == FormStatus.INVALID || formStateValidationStep3 == FormStatus.IGNORED_FOR_VALIDATION;

          if (stateStep1 && stateStep2 && stateStep3) {
            // all steps have finished the validation ( with or without success )
            var form1IsValidOrSkipped = (formStateValidationStep1 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep1 == FormStatus.VALID)?true:false;
            var form2IsValidOrSkipped = (formStateValidationStep2 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep2 == FormStatus.VALID)?true:false;
            var form3IsValidOrSkipped = (formStateValidationStep3 == FormStatus.IGNORED_FOR_VALIDATION || formStateValidationStep3 == FormStatus.VALID)?true:false;

            if (form1IsValidOrSkipped) 
            {
              allowedStep = 2;
            }

            if (form1IsValidOrSkipped && form2IsValidOrSkipped)
            {
              allowedStep = 3;
            }

            if (form1IsValidOrSkipped && form2IsValidOrSkipped && form3IsValidOrSkipped)
            {
              allowedStep = 4;
              calculer();
            }

            ResetStepper();
            setStep(allowedStep);
          }
        }
      }
    }
  }, [formStateValidationStep1,formStateValidationStep2,formStateValidationStep3]);


  const handleButtonStepChange = (askForNextStep: boolean) => {
    if (askForNextStep) {
      //RequestStepChange(step + 1);
      RequestNextStep(step + 1 );
    }
    else
    {
      if(step > 1)
      {
        setStep(step - 1);
      }
    }
  };

  // COMPUTE SALARYSIM DATA

  const calculer = () => {

    // Mapping et traitement du webservice
    // mapper les data
    var salarySimInputPostData = isSimpleSimulationMode ? MapService(salarySimFormData, isSimpleSimulationMode):MapService(salarySimAdvancedFormData, isSimpleSimulationMode);

    setSalarySimulationInProgress(true);

    // poster les data au ws
    var salarySimResultData = SalarySimService(salarySimInputPostData,getServiceUrl(),currentLanguage, configKeys.version);
    salarySimResultData
      .then((Result) => {
        setSalarySimulationInProgress(false);

        if (typeof Result == "string") {
          //toast(getKeyFromKeyId("ERROR_SERVER_DATA"), {type: "error",theme: "colored",autoClose: 5000,hideProgressBar: true,closeOnClick: true,position: "top-left", className: 'toastFullWidth'});
          popToast(toastType.Error, getKeyFromKeyId("ERROR_SERVER_DATA"));
        }
        else
        {
          if(computeButtonStepDisplay == false) // display the calc button everywhere
          {
            setComputeButtonStepDisplay(true);
          }

          if (Result.resultOK) {
            //Recompute Brut income

            //this part stays here until we're certain it is safe to add a field to the backend result class

            var montant = 0;
            montant = Result.T10 - salarySimInputPostData.commissions - salarySimInputPostData.avantages_nature - salarySimInputPostData.avantages_nature_voiture - salarySimInputPostData.Montant_Imposable_Pp_Ordinaire;
            // Lc le 30/03/2017
            montant = montant - salarySimInputPostData.Droits_Auteur;

            salarySimInputPostData.brut = montant;

            if (Result.Scenario_1er_Engage == null) {
              Result.Scenario_1er_Engage = new Array<Cl_Pacible>();
            }

            if (salarySimInputPostData.commission_paritaire) {
              let parseJc = parseInt(salarySimInputPostData.commission_paritaire);
              if (!isNaN(parseJc))
              {
                Result.ReadableJc = {
                  keyX: getJointComiteeKey(parseJc, true, "en"),
                  keyFr: getJointComiteeKey(parseJc, true, "fr"),
                  keyNl: getJointComiteeKey(parseJc, true, "nl")
                }
              }
            }
          }
          else{
            //toast(getKeyFromKeyId(Result.message), {type: "error",theme: "colored",autoClose: 5000,hideProgressBar: true,closeOnClick: true,position: "top-left", className: 'toastFullWidth'});
            popToast(toastType.Error, getKeyFromKeyId(Result.message));
          }


          //stocker resultat dans contexte
          UpdateSalarySimMappedData(salarySimInputPostData);
          UpdateSalarySimResultData(Result as ResultData);
        
          
        }
      })
      .catch((e) => {
        /*toast(getKeyFromKeyId("ERROR_SERVER_DATA"), {
          type: "error",
          theme: "colored",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          position: "top-left",
          className: 'toastFullWidth'
        });*/
        popToast(toastType.Error, getKeyFromKeyId("ERROR_SERVER_DATA"));
      });
  };

  // DISPLAY

  const FormStepDisplay = () => {
    return (
      <>
        {/* STEP 1 */}
        <Step1 formStep={1} isCurrentForm={step == 1 ? true : false} requestFormValidation={requestFormValidation} formValidationCallback={(formStep: number, formValSuccess: boolean) => FormValidationCallback(formStep, formValSuccess)} formPrestaLoaded={(s : number) => PrestaDataLoadedCallBack(s)}></Step1>

        {/* STEP 2 SIMPLE */}
        {isSimpleSimulationMode == true && (
          <Step2Simple formStep={2} isCurrentForm={step == 2 ? true : false} requestFormValidation={requestFormValidation} formValidationCallback={( formStep: number,formValSuccess: boolean) => FormValidationCallback(formStep, formValSuccess)} formPrestaLoaded={(s : number) => PrestaDataLoadedCallBack(s)}></Step2Simple>
        )}

        {/* STEP 2 ADVANCED */}
        {isSimpleSimulationMode == false && (
          <Step2Advanced isCurrentForm={step == 2 ? true : false} formStep={2} requestFormValidation={requestFormValidation} formValidationCallback={( formStep: number,formValSuccess: boolean) => FormValidationCallback(formStep, formValSuccess)} formPrestaLoaded={(s : number) => PrestaDataLoadedCallBack(s)}></Step2Advanced>
        )}

        {/* STEP 3 SIMPLE ( RESULTS ) */}
        {isSimpleSimulationMode == true && (
          <Step3ResultSimple isCurrentForm={step == 3 ? true : false} formStep={3}></Step3ResultSimple>
        )}

        {/* STEP 3 ADVANCED */}
        {!isSimpleSimulationMode && (
          <Step3Advanced isCurrentForm={step == 3 ? true : false} formStep={3} requestFormValidation={requestFormValidation} formValidationCallback={(formStep: number,formValSuccess: boolean) => FormValidationCallback(formStep, formValSuccess)} formPrestaLoaded={(s : number) => PrestaDataLoadedCallBack(s)}></Step3Advanced>
        )}

        {/* STEP 4 ADVANCED ( RESULTS ) */}
        {isSimpleSimulationMode == false && (
          <Step3ResultSimple isCurrentForm={step == 4 ? true : false} formStep={4}></Step3ResultSimple>
        ) }
      </>
    );
  };

  return (
    <>
      <GSOHeaderComponent />

      <SimulationBlockerComponent displayActive={salarySimulationInProgress} />

      <main id="main" className="main wf-section">
        <ToastContainer />

        <div id="principal-container" className="w-layout-grid grid">
          <section id="section-title" className="section-titre w-node-_2eb4fdd6-7858-fd81-a546-798333ef6cd0-416cf1c7">
            <LanguageSelectorComponent />
            <div id="principal-title" className="titre-info">
              <h2 id="title" className="titre w-node-_7f2a2f85-d8cf-73a0-ea22-6527fbc43af1-416cf1c7">
                {getKeyFromKeyId("SALARYSIM_TITLE")}
              </h2>
            </div>
          </section>

          {<SimulationMode />}

          <div id="section-form" className="principal-section w-node-_55d6e6fd-8ced-639a-f228-73dc866008d6-416cf1c7 w-form">
            <>
              {
                <Stepper currentStep={step} requestStepChange={RequestStepChange}></Stepper>
              }
              {FormStepDisplay()}
            </>
          </div>
          <p id="legende" className="legend marge">
            {step == 1 && <>{getKeyFromKeyId("DISCLAIMER_PERS_STATUS")} <br/><br /></>}
            {getKeyFromKeyId("CLAUSE_NON_RESPONSABILITE1")}{getKeyFromKeyId("CLAUSE_NON_RESPONSABILITE2")}{getKeyFromKeyId("CLAUSE_NON_RESPONSABILITE3")}
          </p>
          <br />
          <br />
          <br />
          <br />
        </div>
        <div id="section-buttons" className="validation-space">
          <div className="group-buttons">
            <button id="button-back" aria-label={getKeyFromKeyId("PREVIOUS")} disabled={step == 1} type="button" onClick={() => handleButtonStepChange(false)} tabIndex={-1} aria-current="page" className={ step > 1 ? "button icon-left" : "button icon-left disable"}>
              <div className={step > 1 ? "button-text" : "button-text disable"}>
                {getKeyFromKeyId("PREVIOUS")}
              </div>
            </button>

            {( computeButtonStepDisplay || ((isSimpleSimulationMode && step == 2) || (isSimpleSimulationMode == false && step == 3))) &&
            <button id="button-calc" aria-label={getKeyFromKeyId("CALCULER")} type="button" onClick={() => ComputeResultButtonClick()} className={salarySimulationInProgress?"button disable":"button buttonCalc"}>
                <div className={salarySimulationInProgress?"button-text calc disable":"button-text calc"}>{getKeyFromKeyId("CALCULER")}</div>
                {salarySimulationInProgress == true && 
                  <Lottie animationData={spinner} autoPlay={true} loop={true} className="lottie-animation" />
                }
              </button>
            }

            {(( isSimpleSimulationMode && step < 2 ) || (isSimpleSimulationMode == false && step < 3)) && (
              <button id="button-next" aria-label={getKeyFromKeyId("NEXT")} type="button" onClick={() => handleButtonStepChange(true)} className="button icon-right" >
                <div className="button-text">{getKeyFromKeyId("NEXT")}</div>
              </button>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}